export default "__VITE_ASSET__CTLnjKwU__"